export default "__VITE_ASSET__Ai_s7Su___"